import { APP_STORE_URL } from "../data/appStore";
import "./GoDarkPage.css";

// §25.5 "album no longer shared" page (Iris · APP_VISUAL_STYLE_SPEC §25.5).
// Rendered when web-serve returns 410 not_shared — the album's owner is not
// entitled (lapsed / grace expired) OR they turned sharing off manually. All
// three resolve to "not currently shared"; the 410 is the only signal, so this
// is ONE page with no branch on WHY. It replaces a dead 404/blank on a link a
// recipient is holding: the warm brand shell keeps the domain trustworthy and
// turns the dead end into a soft install (the acquisition loop).

/** Neutral pause disc — says "paused, not broken." NOT a warning/broken-image
 *  glyph (Iris): two calm rounded bars in a soft accent-tint circle. */
function PauseDisc() {
  return (
    <div className="godark__disc" aria-hidden="true">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <rect x="7" y="5.5" width="3.4" height="13" rx="1.7" fill="var(--muted)" />
        <rect x="13.6" y="5.5" width="3.4" height="13" rx="1.7" fill="var(--muted)" />
      </svg>
    </div>
  );
}

export function GoDarkPage() {
  return (
    <div className="godark">
      <header className="godark__wordmark label">Minnea</header>

      <main className="godark__main">
        <PauseDisc />
        <h1 className="godark__title">This album isn’t being shared right now.</h1>
        <p className="godark__line">
          The person who shared it has turned sharing off. If they turn it back
          on, this link will work again.
        </p>
        <a
          className="btn btn--primary godark__cta"
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Get Minnea
        </a>
      </main>

      <footer className="godark__foot">Made with Minnea</footer>
    </div>
  );
}
